const data = {
  pageName: "SmartBill",
  isPageValid: true,
  settlementsLimit: "12",

  services: {
    translations: {
      url: "smartBill/translations",
      params: {}
    },
    balance: {
      url: "smartBill/balance",
      params: {}
    },
    history: {
      url: "smartBill/history",
      params: {}
    }
  },

  parameters: {
    period: "27/08/2019-26/09/2019",
    pdf: "4e42963ae30d4be9a204e3caec6f4a8c",
    key: "e599e0d6dc457a186dbcd0e417c612fe8558f39f",
    ba: "58040171",
    dID: "1"
  },

  footer: {
    links:
      '<a href="https://www.vodafone.gr/" target="_blank">www.vodafone.gr</a><br/><a href="https://www.vodafone.gr/vodafone-ellados/oroi-chrisis/" target="_blank">Όροι &amp; προϋποθέσεις</a>'
  },

  externalContent: {
    SmartBill: {
      right: "/ext_files/test-pages/smartBill-side-content.html",
      bottom: "/ext_files/test-pages/smartBill-tiles-content.html"
    }
  }
};

exports.data = data;
